<template>
    <section style="margin:18px;">
        <v-btn @click="OpenAddDialog">Add Banners</v-btn>
        <v-btn @click="OpenCourseDialog">Add Homepage Courses</v-btn>
        <app-add-banners :dialog='AddDialog' @close='CloseDialog'></app-add-banners>
        <app-add-homepage ref="homepagecourse" :dialog='AddCourseDialog' @close='CloseDialog'></app-add-homepage>
        <app-banner-table></app-banner-table>
    </section>
</template>
<script>

import appAddBanners  from '../views/dialogs/AddBanner'
import appBannerTable from '../views/tables/BannersTable'
import appAddHomepage from '../views/dialogs/HomepageCourseCustom'

export default {
    components:{
        appAddBanners,
        appBannerTable,
        appAddHomepage
    },
    data(){
        return {
            AddDialog       : false,
            AddCourseDialog : false
        }
    },
    methods:{
        OpenAddDialog(){
            
            this.AddDialog = true
        },
        OpenCourseDialog(){

            this.$refs.homepagecourse.GetCourseDetailsList()
            this.AddCourseDialog = true
            
        },
        CloseDialog(){

            this.AddDialog       = false
            this.AddCourseDialog = false

        }
    },
    mounted(){
        // this.$eventHub.$emit("LOADING",'false')
        this.$eventHub.$emit("LOADING",'false')
    }
}   
</script>
<style>

</style>
